import { createContext } from "react";

export const EntrepreneurProfilesContext = createContext();